"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _core = _interopRequireDefault(require("./core"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Relay = exports["default"] = /*#__PURE__*/function (_Core) {
  function Relay(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Relay);
    _this = _callSuper(this, Relay, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.installDevice = _this.installDevice.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Relay, _Core);
  return (0, _createClass2["default"])(Relay, [{
    key: "getState",
    value: function getState() {
      var _this2 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        _this2.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          origin: 'sdk-' + _this2.appName,
          requestUuid: "",
          action: 'System.Relay.State'
        }));
        _this2.connection.on("messaging", function (data) {
          if (data['requestUuid'] === uuid) {
            resolve(data);
          }
        });
      });
    }
  }, {
    key: "installDevice",
    value: function installDevice(code) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        _logger["default"].info('Attempting installation', "Code sent: ".concat(code), 'Relay');
        var uuid = (0, _uuid.v4)();
        _this3.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          requestUuid: "",
          origin: 'sdk-' + _this3.appName,
          action: 'System.Relay.Install',
          data: JSON.stringify({
            installation_code: code
          })
        }));
        _this3.connection.on("messaging", function (message) {
          if (message.action === 'System.Relay.Install.Response') {
            var data = JSON.parse(message.data);
            if ('error' in data) {
              _logger["default"].error('Installation failed', data.error.message, 'Relay');
              reject(data.error);
            } else {
              _logger["default"].info('Device installed', message.data, 'Relay');
              resolve(data);
            }
          }
        });
      });
    }
  }, {
    key: "SetupVision",
    value: function SetupVision(server_id, cloud_server) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)();
        _this4.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          origin: 'sdk-' + _this4.appName,
          action: 'System.Relay.SetupVision',
          data: JSON.stringify({
            server_id: server_id,
            cloud_server: cloud_server
          })
        }));
        _this4.connection.on("messaging", function (message) {
          if (message.action === 'System.Relay.SetupVision.Response') {
            var data = JSON.parse(message.data);
            if ('error' in data) {
              _logger["default"].error('SetupVision failed', data.error.message, 'Relay');
              reject(data.error);
            } else {
              resolve(data);
            }
          }
        });
      });
    }
  }, {
    key: "CheckCode",
    value: function CheckCode(otp, cloud_server) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)();
        _this5.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          origin: 'sdk-' + _this5.appName,
          action: 'System.Relay.CheckCode',
          data: JSON.stringify({
            otp: otp,
            cloud_server: cloud_server
          })
        }));
        _this5.connection.on("messaging", function (message) {
          if (message.action === 'System.Relay.CheckCode.Response') {
            var data = JSON.parse(message.data);
            if ('error' in data) {
              _logger["default"].error('CheckCode failed', data.error.message, 'Relay');
              reject(data.error);
            } else {
              resolve(data);
            }
          }
        });
      });
    }
  }, {
    key: "FetchVariables",
    value: function FetchVariables() {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)();
        _this6.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          origin: 'sdk-' + _this6.appName,
          action: 'System.Relay.FetchVariables',
          data: "{}"
        }));
        _this6.connection.on("messaging", function (message) {
          if (message.action === 'System.Relay.FetchVariables.Response') {
            var data = JSON.parse(message.data);
            if ('error' in data) {
              _logger["default"].error('FetchVariables failed', data.error.message, 'Relay');
              reject(data.error);
            } else {
              resolve(data);
            }
          }
        });
      });
    }
  }, {
    key: "CheckDocker",
    value: function CheckDocker() {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)();
        _this7.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          origin: 'sdk-' + _this7.appName,
          action: 'System.Relay.CheckDocker',
          data: "{}"
        }));
        _this7.connection.on("messaging", function (message) {
          if (message.action === 'System.Relay.CheckDocker.Response') {
            var data = JSON.parse(message.data);
            if ('error' in data) {
              _logger["default"].error('CheckDocker failed', data.error.message, 'Relay');
              reject(data.error);
            } else {
              resolve(data);
            }
          }
        });
      });
    }
  }]);
}(_core["default"]);